import { DefaultBreadcrumbProviderFactory } from "./breadcrumbDefaultProvider";

export class BreadcrumbBindings {
  /** Sets the delegate implementation for layout construction of breadcrumb. */
  provider = "<";

  updateStateOnce = "<";
}

/** The type of a breadcrumb item */
export type BreadcrumbItemType = "url" | "state";

/** Implement this provider to manipulate breadcrumb controller */
export interface BreadcrumbProvider {
  /** Breadcrumb controller will pass a update function for you to use to update the items in breadcrumb */
  registerUpdater(updatefn: () => {}): void;
  /** Get items array in breadcrumb controller */
  get(): BreadcrumbItem[];
}

/** Breadcrumb item definition */
export interface BreadcrumbItem {
  /** The name to display in the breadcrumb for this item */
  displayName: string;
  /** The type of the item */
  type: BreadcrumbItemType;
  /** The stateName of url address of the item */
  link: string;
}

export class BreadcrumbController {
  public provider: BreadcrumbProvider;
  public updateTriggerEvent: string;
  public items: BreadcrumbItem[];
  public updateStateOnce: boolean;
  // @ngInject
  constructor(private $scope: ng.IScope, private defaultBreadcrumbProviderFactory: DefaultBreadcrumbProviderFactory) {}

  $onInit() {
    if (!this.provider) {
      this.provider = this.defaultBreadcrumbProviderFactory.create(this.$scope);
    }

    this.provider.registerUpdater(() => (this.items = this.provider.get()));
  }
}
export const sdBreadcrumb: ng.IComponentOptions = {
  controller: BreadcrumbController,
  templateUrl: "../ShellCommon/Controls/breadcrumb/breadcrumb.html",
  bindings: <any>new BreadcrumbBindings()
};
